const ScrollShadow = (nodeElement, setFirstChildHeight) => {
    const onScroll = () => {
        const { 
            scrollWidth = 0,
            scrollLeft = 0,
            offsetWidth = 0,
            offsetHeight = 0,
            scrollTop = 0,
            scrollHeight = 0
        } = nodeElement || {}

        const scrollShadowOpacity = 0.2
        const hasOverflowLeft = Boolean(scrollLeft > 0)
        const hasOverflowRight = Boolean(scrollLeft + offsetWidth < scrollWidth)

        const hasOverflowTop = Boolean(scrollTop > 0)
        const hasOverflowBottom = Boolean(scrollTop + offsetHeight < scrollHeight)


        if (setFirstChildHeight) {
            const shadowHeight = nodeElement.firstChild.offsetHeight
            nodeElement.style.setProperty('--scroll-shadow-height', shadowHeight ? `${shadowHeight / 10}rem` : null)
            //nodeElement.style.setProperty('--scroll-shadow-width', shadowHeight ? `${shadowHeight / 10}rem` : null)
        }
        nodeElement.style.setProperty('--scroll-shadow-left-opacity', (hasOverflowLeft ? scrollShadowOpacity : 0))
        nodeElement.style.setProperty('--scroll-shadow-right-opacity', (hasOverflowRight ? scrollShadowOpacity : 0))

        nodeElement.style.setProperty('--scroll-shadow-top-opacity', (hasOverflowTop ? scrollShadowOpacity : 0))
        nodeElement.style.setProperty('--scroll-shadow-bottom-opacity', (hasOverflowBottom ? scrollShadowOpacity : 0))

    }
    onScroll()
    nodeElement.addEventListener('scroll', onScroll, { passive:true })
    nodeElement.addEventListener('updateScrollShadow', onScroll, { passive: true })
}

export default ScrollShadow

